import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {MultiSelectComponent, MultiSelectFilter} from '../multi-select-component';
import {ToastService} from '../../services/toast.service';
import {MatCheckbox} from '@angular/material/checkbox';
import {MatDivider} from '@angular/material/divider';
import {MatButton} from '@angular/material/button';
import { UserManagementService } from '../../../data/users/user-management.service';
import { UserModel } from '../../models/User';

export class UserEmailAsId extends UserModel {
  id: string;
}

/**
 * This component allows to create a multi-select filter of emails - users with Admin or Supervisor roles.
 * It either emits 'undefined' value if no filter is set or an array of entities.
 *
 * In addition, it saves the state of the filter to URL params and browser's storage.
 */

@Component({
  selector: 'app-user-filter',
  templateUrl: './user-filter.component.html',
  styleUrls: ['./user-filter.component.scss'],
  imports: [
    MatCheckbox,
    MatDivider,
    MatButton
  ]
})
export class UserFilterComponent extends MultiSelectComponent<UserEmailAsId> implements OnInit {

  SETTINGS_KEY = 'selectedEmails';
  USE_FULLY_CHECKED_AS_DEFAULT = false;

  @Input() origin;
  @Output() filterChanged = new EventEmitter<MultiSelectFilter<UserEmailAsId>>();

  constructor(
    private userService: UserManagementService,
    private readonly toast: ToastService,
  ) {
    super();
  }

  ngOnInit() {
    // delayed init to workaround failing chip label initialization :-(
    setTimeout(
      async () => this.initComponent(
        (await this.userService.getSupervisorList()).data.map(user => {
          const userEmailAsId: UserEmailAsId = user as UserEmailAsId;
          userEmailAsId.id = user.email;
          return userEmailAsId;
        }),
      ),
      500,
    );
  }

  getLabel(item: UserEmailAsId): string {
    return `${item.givenName} ${item.familyName}`;
  }

  onApply() {}

}
